module.exports = __webpack_public_path__ + "static/media/dog-7.54ffab26.jpg";